export class EnaioAddonRecherche {
}
